import React, { useMemo } from "react";

import { faXmark } from "@fortawesome/pro-solid-svg-icons";
import { faCircleCheck } from "@fortawesome/pro-solid-svg-icons/faCircleCheck";
import { faCircleExclamation } from "@fortawesome/pro-solid-svg-icons/faCircleExclamation";
import { faCircleInfo } from "@fortawesome/pro-solid-svg-icons/faCircleInfo";
import { faCircleXmark } from "@fortawesome/pro-solid-svg-icons/faCircleXmark";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { bem } from "@react-md/utils";
// eslint-disable-next-line no-restricted-imports
import AntdAlert, { AlertProps as AntDAlertProps } from "antd/es/alert";
import cn from "classnames";

const block = bem("mmc-alert");

export interface AlertProps extends AntDAlertProps {}

export const Alert = ({ className, closeIcon, type, ...restProps }: AlertProps) => {
  const icon = useMemo(() => {
    switch (type) {
      case "error":
        return faCircleXmark;
      case "success":
        return faCircleCheck;
      case "warning":
        return faCircleExclamation;
      default:
        return faCircleInfo;
    }
  }, [type]);

  return (
    <AntdAlert
      className={cn(block(), className)}
      closeIcon={
        closeIcon ? closeIcon : <FontAwesomeIcon className={block("close-icon")} icon={faXmark} />
      }
      icon={<FontAwesomeIcon className={block("icon")} icon={icon} />}
      type={type}
      {...restProps}
    />
  );
};
